import { Injectable } from '@angular/core';
import { Channel } from 'ops/common/models/channel';

@Injectable({
    providedIn: 'root',
})
export class ChannelFormatterService {

    getChannelType(channel: Channel) {
        return channel.opsData.channelType || '*';
    }

    getFcuNum(channel: Channel) {
        return channel.fcuData.fcuNo ? `${channel.fcuData.fcuNo}` : '*';
    }

    getInputAddress(channel: Channel) {
        const fcuNo = channel.fcuData.fcuNo;
        const fuNo = channel.fcuData.inputData.fuInputAddress.fuNo;
        const slotNo = channel.fcuData.inputData.fuInputAddress.slotNo;
        const pinNo = channel.fcuData.inputData.fuInputAddress.pin;

        let str = `${fcuNo} *`;

        if(fcuNo && fuNo && slotNo && pinNo) {
            str = `${fcuNo} ${fuNo} - ${slotNo} - ${pinNo}`;
        }

        return str;
    }

    getOutputSignalType(channel: Channel) {
        return channel.fcuData.outputData.misc.signalType || '*';
    }

    getOutputAddress(channel: Channel) {
        const fcuNo = channel.fcuData.fcuNo;
        const fuNo = channel.fcuData.outputData.fuOutputAddress.fuNo;
        const slotNo = channel.fcuData.outputData.fuOutputAddress.slotNo;
        const pinNo = channel.fcuData.outputData.fuOutputAddress.pin;

        let str = `${fcuNo} *`;

        if(fcuNo && fuNo && slotNo && pinNo) {
            str = `${fcuNo} ${fuNo} - ${slotNo} - ${pinNo}`;
        }

        return str;
    }
}
